import { I18n } from '@lingui/core';

// It should use same formatting as useFormatNumber hook
export function formatNumber(i18n: I18n) {
  return (number: number) => i18n.number(number);
}
